import { Request } from "./HttpService";

export const BusinessAreaService = {
  getBusinessAreas(pageNumber, pageSize, searchObject) {
    let url = `vitae/businessArea/${pageNumber}/${pageSize}`;
    if (searchObject.description)
      url += `?description=${searchObject.description}`;
    return Request(url, "GET");
  },
  createOrUpdate(businessArea) {
    return Request("vitae/businessArea", "POST", businessArea);
  },
  delete(id) {
    return Request(`vitae/businessArea/${id}`, "DELETE");
  },
  getbyId(id) {
    return Request(`vitae/businessArea/${id}`, "GET");
  }
};
